import React from 'react';
interface SectionHeadingProps {
  id: string;
  title: React.ReactNode;
  eyebrow?: string;
  lead?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}

/** Serif section heading with an optional green eyebrow. */
export function SectionHeading({
  id,
  title,
  eyebrow,
  lead,
  tone = 'light',
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  const centered = align === 'center';
  return <div className={`${centered ? 'mx-auto text-center' : ''} max-w-3xl ${className}`} data-id="element-135" data-mp="gj6utb0yxdiy">
      {eyebrow && <p className={`label-tech flex items-center gap-3 ${centered ? 'justify-center' : ''} ${dark ? 'text-olive-light' : 'text-forest'}`} data-id="element-136" data-mp="1v3og0j0jztm">
          <span className="h-px w-6 shrink-0 bg-current" aria-hidden data-id="element-137" data-mp="ujhloe2a2s44" />
          {eyebrow}
        </p>}
      <h2 id={id} className={`text-balance font-brand text-[1.8rem] font-bold leading-[1.18] tracking-[-0.01em] min-[390px]:text-[1.95rem] sm:text-[2.45rem] lg:text-[2.75rem] ${eyebrow ? 'mt-4' : ''} ${dark ? 'text-ivory' : 'text-ink'}`} data-id="element-138" data-mp="zahhth3kp65k">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-[1rem] leading-relaxed sm:text-[1.06rem] ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'} ${dark ? 'text-parchment' : 'text-stone'}`} data-id="element-139" data-mp="230k5q436end0">
          {lead}
        </p>}
    </div>;
}